import { render } from "./Toast.vue?vue&type=template&id=2e54afd3"
import script from "./Toast.vue?vue&type=script&lang=js"
export * from "./Toast.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rebec\\Desktop\\dev\\dma-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__